import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Logout, Settings, LiveTv } from '@mui/icons-material';
import { LOGOUT, PRIVATE_ADMIN, PRIVATE_USER_CHANNELS } from 'config/router/paths';
import { Link, useLocation } from 'react-router-dom';
import { useAuthContext } from 'contexts/authContext';
import { getM3UList } from 'utils/getM3UList';
import AppLoader from 'components/common/AppLoader';


export function MainListItems() {
  const [listItems, setListItems] = React.useState([]);
  const { getPublicPathFromLocalStorage } = useAuthContext();
  const location = useLocation();
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        var m3uList = await getM3UList(getPublicPathFromLocalStorage());
        var auxListItems = [];
        Object.keys(m3uList).forEach((group) => {
          const to = PRIVATE_USER_CHANNELS + '/' + group;
          auxListItems.push(
            <ListItemButton
              key={group}
              component={Link}
              to={to}
              selected={location.pathname === to}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <LiveTv fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={group}
                primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: 500 }}
              />
            </ListItemButton>
          );
        });
        setListItems(auxListItems);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [location.pathname]);
  return (
    <React.Fragment>
      {listItems.length > 0 ? listItems : <AppLoader />}
    </React.Fragment>
  );
}

export function SecondaryListItems(){
  const { isAdmin } = useAuthContext();
  const location = useLocation();
  var listItems = [];
  if (isAdmin()) {
    listItems.push(
      <ListItemButton
        key={PRIVATE_ADMIN}
        component={Link}
        to={PRIVATE_ADMIN}
        selected={location.pathname.startsWith(PRIVATE_ADMIN)}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          <Settings fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary="Administración"
          primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: 500 }}
        />
      </ListItemButton>
    );
  }
  listItems.push(
    <ListItemButton key={LOGOUT} component={Link} to={LOGOUT}>
        <ListItemIcon sx={{ minWidth: 36 }}>
          <Logout fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary="Cerrar Sesión"
          primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: 500, color: 'error.main' }}
        />
    </ListItemButton>
  );
  return (
    <React.Fragment>
      {listItems}
    </React.Fragment>
  );
}
